import { DateTime } from 'luxon'
import { Instance, types } from 'mobx-state-tree'

export const UserSubscriptionDetail = types
  .model('UserSubscriptionDetail')
  .props({
    id: types.identifierNumber,
    product_title: types.string,
    description: types.maybeNull(types.string),
    purchased_date: types.maybe(types.maybeNull(types.string)),
    color: types.maybe(types.maybeNull(types.string)),
    product_content: types.array(types.frozen()),
    expiration_date: types.maybeNull(types.string),
  })
  .views((self) => ({
    get isActive() {
      if (!self.expiration_date) return true
      return DateTime.fromISO(self.expiration_date) > DateTime.now()
    },
    get isExpired() {
      if (!self.expiration_date) return false
      return DateTime.fromISO(self.expiration_date) < DateTime.now()
    },
    get isExpiring() {
      if (!self.expiration_date) return false
      const expiration = DateTime.fromISO(self.expiration_date)
      const now = DateTime.now()
      return expiration > now && expiration <= now.plus({ days: 7 })
    },
    get status() {
      if (this.isExpired) {
        return 'expired'
      } else if (this.isExpiring) {
        return 'expiring'
      } else {
        return 'active'
      }
    },
  }))

export type UserSubscriptionDetailType = Instance<typeof UserSubscriptionDetail>
